import { render, staticRenderFns } from "./Specialty.vue?vue&type=template&id=61e0f05f&scoped=true"
import script from "./Specialty.vue?vue&type=script&lang=js"
export * from "./Specialty.vue?vue&type=script&lang=js"
import style0 from "./Specialty.vue?vue&type=style&index=0&id=61e0f05f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e0f05f",
  null
  
)

export default component.exports